var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "option-menu-item",
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm._t("default", function () {
        return [
          _vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(),
          _c("span", { domProps: { textContent: _vm._s(_vm.title) } }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }